export default "__VITE_PUBLIC_ASSET__475ad3d5__"